import React from "react";
import clsx from "clsx";
const CustomDayButton = (props, price, displayPriceIndicator) => {
  const { day, modifiers, ...buttonProps } = props;

  const ref = React.useRef(null);
  React.useEffect(() => {
    if (modifiers.focused) ref.current?.focus();
  }, [modifiers.focused]);

  if (displayPriceIndicator && props.disabled !== true) {
    console.log("day", props.day?.date, price);
    var dotClass = clsx(
      { "w-2 h-2 rounded-full": price?.pricingStatus!="Unknown" },
      { "bg-green-300": price?.pricingStatus == "low" },
      { "bg-yellow": price?.pricingStatus == "mid" },
      { "bg-red": price?.pricingStatus == "high" }
    );
    return (
      <button ref={ref} {...buttonProps} className={buttonProps.className + " flex-col"}>
        <div>
          {buttonProps.children}
        </div>
        <div className="h-2 text-center">
          <div className={dotClass}></div>
        </div>
      </button>);
  } else {
    return (
      <button ref={ref} {...buttonProps} className={buttonProps.className + " flex-col"}>
        <div>
          {buttonProps.children}
        </div>
        <div className="h-2 text-center">
        </div>
      </button>);
  }

}
export default CustomDayButton;
